//
import UserModel from '@/models/General/GUser'

//
export default [
    {
        name: "g_user_id",
        type: "autocomplete-model",
        props: {
            itemText: "hr_employee_full_name",
            itemValue: "id",
            label: "Responsable",
            model: UserModel,
            noDataText: "Sin usuarios.",
            noObject: true,
        },
    },
    {
        name: "matched",
        type: "autocomplete",
        props: {
            items: [
                {
                    text: "Si",
                    value: 1,
                },
                {
                    text: "No",
                    value: 0,
                },
            ],
            label: "Emparejado",
            noDataText: "Sin usuarios.",
            noObject: true,
        },
    },
]
